export const borderRadius = {
  small: "10px",
  big: "20px",
};
